import { ResellerItem } from '@vendasta/store';
import { AnalyticsItem, AnalyticsTransaction } from '../../../analytics/interface';
import { PurchaseCost } from '../../../core/billing/purchase-cost';
import { ActivationResult } from '../activate-app/interface';

export function filterMapByIds<T>(selectedIds: string[], m: Map<string, T>): Map<string, T> {
  if (!selectedIds || selectedIds.length === 0 || !m || m.size === 0) {
    return new Map();
  }
  return selectedIds.reduce((currMap, id) => {
    const item = m.get(id);
    if (item) {
      currMap.set(id, item);
    }
    return currMap;
  }, new Map<string, T>());
}

export function convertResellerItemsAndPricingMapToAnalyticsItems(
  pricingMap: Map<string, PurchaseCost>,
  resellerItemMap: Map<string, ResellerItem>,
  activatedItemMap: Map<string, number>,
): AnalyticsItem[] {
  return Array.from(activatedItemMap.keys()).reduce((acc, id) => {
    const quantity = activatedItemMap.get(id);
    if (quantity <= 0) {
      return acc;
    }
    const resellerItem = resellerItemMap.get(id);
    const pricing = resellerItem ? pricingMap.get(resellerItem.billingId) : null;
    const analyticsItem = buildAnalyticsItem(pricing, quantity, resellerItem);
    acc.push(analyticsItem);
    return acc;
  }, []);
}

export function buildTransaction(
  transactionId: string,
  partnerId: string,
  marketId: string,
  analyticsItems: AnalyticsItem[],
): AnalyticsTransaction {
  const totalRevenue = (analyticsItems || []).reduce((total, item) => {
    if (item.quantity > 0) {
      total = total + item.price * item.quantity;
    }
    return total;
  }, 0);
  return {
    transactionId: transactionId,
    revenue: totalRevenue,
    affiliation: `${partnerId},${marketId}`,
  } as AnalyticsTransaction;
}

/* generate random uuidv4 */
export function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // tslint:disable-next-line:no-bitwise
    const r = (Math.random() * 16) | 0,
      // tslint:disable-next-line:no-bitwise
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function convertActivationResultsToQuantityMap(activationResults: ActivationResult[]): Map<string, number> {
  return (activationResults || []).reduce((m, curr) => {
    const currentCount = m.get(curr.appId) || 0;
    m.set(curr.appId, currentCount + 1);
    return m;
  }, new Map<string, number>());
}

function buildAnalyticsItem(pricing: PurchaseCost, quantity: number, resellerItem: ResellerItem): AnalyticsItem {
  resellerItem = resellerItem || ({} as ResellerItem);
  if (!pricing) {
    if (resellerItem && resellerItem.isCustom) {
      pricing = new PurchaseCost();
      pricing.totalCost = resellerItem.price * quantity;
      pricing.currency = resellerItem.currency;
    } else {
      pricing = { totalCost: 0, currency: 'USD' } as PurchaseCost;
    }
  }
  return {
    name: resellerItem.name || 'NO NAME',
    id: resellerItem.billingId || 'NO SKU',
    category: (resellerItem.lmiCategories || []).reduce((s, cat) => (s ? `${s},${cat}` : `${cat}`), ''),
    price: pricing.totalCost ? pricing.totalCost / quantity : 0,
    currency: pricing.currency || 'USD',
    quantity: quantity,
  };
}
